<template lang="html">
	<div style="height:100%;">
		<div class="handleBox flex flex-jc-sb flex-ai-c">
			<p class="title">积分配制 ></p>
			<div class=""></div>
		</div>
		
		<div class="zsBox" v-if="list.length>0">
			<div class="flex zsList">
				<div class="flex flex-ai-c">
					<label>积分抵用比例<i class="el-icon-warning" @click="tip(1)"></i>：</label>
					<el-input v-model="list[0].score" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" size="small"></el-input>
				</div>
			</div>
			
			<div class="flex zsList">
				<div class="flex flex-ai-c">
					<label>签到积分数值<i class="el-icon-warning" @click="tip(2)"></i>：</label>
					<el-input v-model="list[1].score" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" size="small"></el-input>
				</div>
			</div>
			
			<div class="flex zsList">
				<div class="flex flex-ai-c">
					<label>直接推广送积分<i class="el-icon-warning" @click="tip(3)"></i>：</label>
					<el-input v-model="list[2].score" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" size="small"></el-input>
				</div>
			</div>
			
			<div class="flex zsList">
				<div class="flex flex-ai-c">
					<label>阅读推广文章<i class="el-icon-warning" @click="tip(4)"></i>：</label>
					<el-input v-model="list[3].score" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" size="small"></el-input>
				</div>
			</div>
			<div class="flex zsList">
				<div class="flex flex-ai-c">
					<label>购买商品返积分<i class="el-icon-warning" @click="tip(5)"></i>：</label>
					<el-input v-model="list[4].score" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" size="small"></el-input>
				</div>
			</div>

			<el-button type="primary" size="small" class="zsBtn" @click="submit">确定</el-button>
		</div>

		<el-dialog :title="title" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false" width="400px">
			<div v-html="tipContent"></div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				
				input: '',
				title: '',
				tipContent: '',
				
				noEmpty: true,
				dialogFormVisible: false,
				
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			getData() {
				this.http.post('/admin/integral/getSetting').then(re => {
					this.list = re;
				})
			},

			// tip
			tip(num) {
				this.dialogFormVisible = true;
				if (num == 1) {
					this.title = '积分抵用规则';
					this.tipContent = '积分使用：' + this.list[0].score + '积分抵1元'
				} else if (num == 2) {
					this.title = '签到积分';
					this.tipContent = '签到反' + this.list[1].score +
						'积分'
				} else if (num == 3) {
					this.title = '推广积分';
					this.tipContent = '被推荐人完成手机号注册验证，推荐人获得' + this.list[2].score + '积分（只有直接推荐才可以有积分）'
				} else if (num == 4) {
					this.title = '推广文章';
					this.tipContent = '推广文章阅读后奖励' + this.list[3].score + '积分，每篇文章阅读只算一次。'
				} else if (num == 5) {
					this.title = '购买商品返积分';
					this.tipContent = '购买商品1元返' + this.list[4].score + '积分'
				}
			},

			submit() {
				this.noEmpty = true;
				this.list.forEach(v => {
					if (!v.score) {
						this.noEmpty = false;
					}
				})
				if (!this.noEmpty) {
					this.$message.error('不得有为空设置！')
				} else {
					this.http.post('/admin/integral/saveSetting', {
						data: this.list
					}).then(() => {
						this.getData();
						this.$message({
							message: '提交成功',
							type: 'success'
						});
					})
				}
			}
		}
	}
</script>
